const adKeyId = {
  H5_Carousel: 'H5_Carousel',
  H5_HomeEntry: 'H5_HomeEntry',
  H5_HomePoint1: 'H5_HomePoint1',
  H5_HomePoint2: 'H5_HomePoint2',
  H5_qybzq: 'H5_qybzq',
  H5_HomePoint: 'H5_HomePoint',
  HomeBanner: 'H5_sub-HomeBanner',
  H5_WalletPoint: 'H5_WalletPoint',
  H5_WalletCarousel: 'H5_WalletCarousel',
  H5_WalletList: 'H5_WalletList',
  H5_MyOrder: 'H5_MyOrder',
  H5_MyList: 'H5_MyList',
  H5_150_ProductArea_Ad_01: 'H5_150_ProductArea_Ad_01',
  H5_150_ProductArea_Ad_02: 'H5_150_ProductArea_Ad_02',
  H5_150_ProductArea_Ad_03: 'H5_150_ProductArea_Ad_03',
  H5_ExploreCarousel: 'H5_ExploreCarousel',
  H5_Explore_GameCenter: 'H5_Explore_GameCenter',
  H5_Explore_PintuanMore: 'H5_Explore_PintuanMore',
  H5_Explore_Lucky666More: 'H5_Explore_Lucky666More',
  H5_Explore_ArticleMore: 'H5_Explore_ArticleMore',
  H5_153_Explore_Zhongyin: 'H5_153_Explore_Zhongyin',
  H5_151_Wallet_Loan: 'H5_151_Wallet_Loan',
  H5_Carousel2: 'H5_Carousel2',
  H5_Yxg: 'H5_Yxg',
  H5_HomePoint: 'H5_HomePoint',
  H5_Video: 'H5_Video',
  H5_QuanYi: 'H5_QuanYi',
  H5_BottomBanner: 'H5_BottomBanner',
  H5_CYJR: 'H5_CYJR',
  H5_CYJR_JHY: 'H5_CYJR_JHY',
  H5_QiTa: 'H5_QiTa',
  H5_400_HomeEntry1: 'H5_400_HomeEntry1',//首页3月改版，第一功能球
  H5_400_HomeEntry2: 'H5_400_HomeEntry2',//首页3月改版，第二功能球
  H5_400_HomePoint1: 'H5_400_HomePoint1',//首页3月改版，第一banner位
  H5_400_HomePoint2: 'H5_400_HomePoint2',//首页3月改版，第二banner位
  H5_400_ExtensionArea: 'H5_400_ExtensionArea',//首页3月改版，推广区（四宫格）
  H5_Group_H_P: 'H5_Group_H_P'
}
const proKeyId = {}
const recKeyId = {}

export {
  adKeyId,
  proKeyId,
  recKeyId
}
